import { Spin } from 'antd';
import React, { Suspense } from 'react';

const RaporLayout = (WraperContent) => {
  return function () {
    return (
      <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0 }}>
        <WraperContent />
      </div>
    );
  };
};

export default RaporLayout;
